export default "__VITE_ASSET__BvH6gzWm__"